import React, { Component } from "react";
import css from "./style.css";
import CSSModule from "react-css-modules";

import Title from "../../component/title";
import Button from "../../component/button";
import { Modal } from "antd";
import moment from "moment";

const CancelBoard = CSSModule(
  ({ data, cancelAction, done }) => {
    const { points } = data;
    if (!points[1]) {
      points[1] = {
        amount: 0,
        last: 0,
      };
    }
    return (
      <div styleName="board">
        <p>
          服務點數 {points[0].amount} 點 剩餘 {points[0].last} 點
        </p>
        <p>每點價值250元，小計 {250 * points[0].last}元</p>
        <p>
          贈品點數 {points[1].amount}點 剩餘 {points[1].last}點
        </p>
        <p>每點價值 0 元，贈品回收</p>
        <hr />
        <p>可退費{250 * points[0].last} 元</p>
        {data.pay_mode === "online" ? (
          <p>退至您的信用卡</p>
        ) : (
          <p>請至教室申請退費</p>
        )}
        {data.pay_mode === "online" && (
          <Button
            styleName="board-button"
            onClick={cancelAction.bind(null, data.serial_no)}
          >
            確定退費
          </Button>
        )}
      </div>
    );
  },
  css,
  { allowMultiple: true }
);

class Board extends Component {
  constructor(props) {
    super(props);
    this.state = {
      test: "235",
      visible: false,
    };
    this.cancelContract = (e) => {
      this.setState({ visible: true });
    };

    this.cancel = (e) => {
      this.setState({ test: "123" });
    };
    this.closeModal = (e) => {
      this.setState({
        visible: false,
      });
    };
  }

  renderVIP(data) {
    const create_time = moment(data.create_time);

    return (
      <div styleName="board">
        <Title styleName="title">VIP服務：一年</Title>
        <p>
          {create_time.format("YYYY/MM/DD")}到
          {create_time.add(1, "year").format("YYYY/MM/DD")}
        </p>
      </div>
    );
  }

  renderPromote(data) {
    const create_time = moment(data.create_time);

    return (
      <div styleName="board">
        <Title styleName="title">{data.remark} </Title>
        <p>{create_time.format("YYYY/MM/DD")}</p>
        <p>
          總共 {data.amount}點，剩餘 {data.last}點
        </p>
      </div>
    );
  }

  renderPoints(obj) {
    const Log = obj.point_use_logs;

    if (obj.type === "charge") {
      return (
        <div>
          <Title styleName="title">
            服務點數 {obj.amount} 點 剩餘 {obj.last} 點
          </Title>
          {Log &&
            Log.map((object, index) => {
              return (
                <p>
                  {" "}
                  {`
                                    ${moment(object.create_time).format(
                                      "YYYY/MM/DD HH:mm"
                                    )}
                                    ${
                                      object.sign_up &&
                                      object.sign_up.class.title
                                    } 
                                    ${
                                      this.props.studentsEntity[
                                        "stu_" + object.sign_up.student_id
                                      ].name
                                    }
                                    使用 ${object.cost_point} 點
                                    `}
                </p>
              );
            })}
        </div>
      );
    } else if (obj.type === "premiums") {
      return (
        <div>
          <Title styleName="title">
            贈品點數 {obj.amount} 點 剩餘 {obj.last} 點
          </Title>
          {Log &&
            Log.map((object, index) => {
              return (
                <p>
                  {" "}
                  {`
                                    ${moment(object.create_time).format(
                                      "YYYY/MM/DD HH:mm"
                                    )}
                                    ${
                                      object.sign_up &&
                                      object.sign_up.class.title
                                    } 
                                    ${
                                      this.props.studentsEntity[
                                        "stu_" + object.sign_up.student_id
                                      ].name
                                    }
                                    使用 ${object.cost_point} 點
                                    `}
                </p>
              );
            })}
        </div>
      );
    }
  }

  render() {
    const { data } = this.props;
    const { points } = data;

    // console.log(data);

    if (data.type === "vip") return this.renderVIP(data);
    if (data.remark) return this.renderPromote(data);

    // const total = points[0].amount + points[1].amount;
    // const last = points[0].last + points[1].last;

    const premiumsLog = points[1] && points[1].point_use_logs;

    const tillNow = moment().diff(moment(data.create_time), "days");

    // console.log(points);

    return (
      <div styleName="board">
        {points.map((obj, index) => {
          return this.renderPoints(obj);
        })}

        {tillNow <= 30 && points[0].type === "charge" && (
          <Button styleName="board-button" onClick={this.cancelContract}>
            申請退費
          </Button>
        )}

        <Modal
          visible={this.state.visible}
          title="退費申請"
          onCancel={this.closeModal}
          cancelText="取消"
          footer={null}
        >
          <CancelBoard
            data={data}
            cancelAction={this.props.cancelAction}
            done={this.props.done}
          />
        </Modal>
      </div>
    );
  }
}

export default CSSModule(Board, css, { allowMultiple: true });



/** WEBPACK FOOTER **
 ** ./src/container/manage/board.js
 **/